import React from 'react';

export interface FooterProps {
    email: string;
}

export function FooterSection(props: FooterProps) {
  return (
    <footer className="footer" style={{ backgroundColor: '#f4f5f6' }}>
      <div className="content has-text-right">
        <p className="is-size-7">Copyright © 2019 株式会社エイジ・エンタテインメント All Rights Reserved.</p>
        <p className="is-size-7">
          お問い合わせ <a className="has-text-primary" href={`mailto:${props.email}`}>{props.email}</a>
        </p>
      </div>
    </footer>
  );
}
